import { destination, point, type Units } from "@turf/turf";
import type { Coordinate } from "./coordinate";
import type Feature from "ol/Feature";

const meters: { units: Units } = { units: 'meters' };

export enum Anchor {
  Center = 'Center',

  BottomCenter = 'Bottom Center',
  BottomLeft = 'Bottom Left',
  BottomRight = 'Bottom Right',

  TopCenter = 'Top Center',
  TopLeft = 'Top Left',
  TopRight = 'Top Right'
}

interface GetAnchorCoordinate {
  anchor: Anchor;
  coordinate: Coordinate;
  heading: number;
  width: number;
  length: number;
}

interface AnchorTranslateOptions {
  coordinate: Coordinate;
  fromAnchor: Anchor;
  toAnchor: Anchor;
  heading: number;
  width: number;
  length: number;
}

// export function createAnchor(options: GetAnchorCoordinate) {

//   const {
//     coordinate,
//     anchor,
//     width,
//     length,
//     heading
//   } = options;

//   let startPosition = point([coordinate.longitude, coordinate.latitude]);

//   switch (anchor) {
//     case Anchor.Center: {
//       startPosition = destination(
//         startPosition,
//         width / 2,
//         -90 + heading,
//         meters,
//       );
//       startPosition = destination(
//         startPosition,
//         length / 2,
//         -180 + heading,
//         meters,
//       );
//       break;
//     }
//     case Anchor.BottomCenter: {
//       startPosition = destination(
//         startPosition,
//         width / 2,
//         -90 + heading,
//         meters,
//       );
//       break;
//     }
//     case Anchor.BottomLeft: {
//       break;
//     }
//     case Anchor.BottomRight: {
//       startPosition = destination(
//         startPosition,
//         width,
//         -90 + heading,
//         meters,
//       );
//       break;
//     }
//     case Anchor.TopCenter: {
//       startPosition = destination(
//         startPosition,
//         width / 2,
//         -90 + heading,
//         meters,
//       );
//       startPosition = destination(
//         startPosition,
//         length,
//         -180 + heading,
//         meters,
//       );
//       break;
//     }
//     case Anchor.TopLeft: {
//       startPosition = destination(
//         startPosition,
//         length,
//         -180 + heading,
//         meters,
//       );
//       break;
//     }
//     case Anchor.TopRight: {
//       startPosition = destination(
//         startPosition,
//         width,
//         -90 + heading,
//         meters,
//       );
//       startPosition = destination(
//         startPosition,
//         length,
//         -180 + heading,
//         meters,
//       );
//       break;
//     }
//     default:
//       break;
//   }
//   return startPosition;
// }

export function createAnchor(options: GetAnchorCoordinate) {
  const { coordinate, anchor, width, length, heading } = options;

  const offset = getAnchorOffset(anchor, width, length);
  let startPosition = point([coordinate.longitude, coordinate.latitude]);

  startPosition = destination(startPosition, offset.width, -90 + heading, meters);
  startPosition = destination(startPosition, offset.length, -180 + heading, meters);

  return startPosition;
}

export function translateAnchor(options: AnchorTranslateOptions) {
  const { coordinate, fromAnchor, toAnchor, heading, width, length } = options;

  if (fromAnchor === toAnchor) {
    return point([coordinate.longitude, coordinate.latitude]);
  }

  const offsetFrom = getAnchorOffset(fromAnchor, width, length);
  const offsetTo = getAnchorOffset(toAnchor, width, length);

  const widthDelta = offsetFrom.width - offsetTo.width;
  const lengthDelta = offsetFrom.length - offsetTo.length;

  let newPosition = point([coordinate.longitude, coordinate.latitude]);

  newPosition = destination(newPosition, widthDelta, -90 + heading, meters);
  newPosition = destination(newPosition, lengthDelta, -180 + heading, meters);

  return newPosition;
}


function getAnchorOffset(anchor: Anchor, width: number, length: number) {
  switch (anchor) {
    case Anchor.Center:
      return { width: width / 2, length: length / 2 };
    case Anchor.BottomCenter:
      return { width: width / 2, length: 0 };
    case Anchor.BottomLeft:
      return { width: 0, length: 0 };
    case Anchor.BottomRight:
      return { width: width, length: 0 };
    case Anchor.TopCenter:
      return { width: width / 2, length: length };
    case Anchor.TopLeft:
      return { width: 0, length: length };
    case Anchor.TopRight:
      return { width: width, length: length };
    default:
      return { width: 0, length: 0 };
  }
}
